import React from "react";
import ReactDOM from "react-dom";

import { observer, inject, Provider } from "mobx-react";
import { extendObservable } from 'mobx';
import { Link } from "react-router-dom";

import StoreButton from './StoreButton'
import NewStoreButton   from './NewStoreButton'


@inject('core')
@observer
export default class StoreOverview extends React.Component {

	componentDidMount() {
		const { core } = this.props
	}

	render() {
		const { core } = this.props
		
		const matrix = core.storesShoppableProductsMatrix

		return <div id="store-overview">
			<h1>{core.stores.length} Stores</h1>
			<table className="listing"><tbody>
			{core.stores.map(store => 
				<tr key={store.store_id} >
					<td><StoreButton store_id={store.store_id} /></td>
					<td><div className="store-info">{matrix[store.store_id].length ? matrix[store.store_id].length + ' product(s)' : ''}</div>
				</td></tr>
			)}
			</tbody></table>
			<NewStoreButton />
		</div>
	}

}
